import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";

interface LeadDialogFooterProps {
  onClose: () => void;
  onDelete: () => void;
  onUpdate: () => void;
  onConvert: () => void;
}

export const LeadDialogFooter = ({ onClose, onDelete, onUpdate, onConvert }: LeadDialogFooterProps) => {
  return (
    <div className="flex justify-between">
      <div className="flex gap-2">
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button variant="destructive">Delete Lead</Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Are you sure?</AlertDialogTitle>
              <AlertDialogDescription>
                This action cannot be undone. This will permanently delete the lead.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Cancel</AlertDialogCancel>
              <AlertDialogAction onClick={onDelete}>Delete</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
      </div>
      <div className="flex gap-2">
        <Button onClick={onUpdate}>
          Save Changes
        </Button>
        <Button onClick={onConvert} className="bg-[#9b87f5] hover:bg-[#7E69AB]">
          Convert to Customer
        </Button>
      </div>
    </div>
  );
};